<div class="newsroom-page-header-wrapper text-center bg-white" *ngIf="title">
    <h1 class="newsroom-page-header-title font-weight-bold text-uppercase text-break m-0">{{ title }}</h1>
</div>

<style>
.newsroom-page-header-wrapper {
  width: 100vw;
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);
}

/* Title: 30px on desktop, 28px on phones. */
.newsroom-page-header-title {
  font-size: 1.875rem;
  line-height: 1.2;
  color: #084F71;
}

/* Mobile: 28px from 375px up, scaling down on narrower phones so short titles stay on one line. */
@media (max-width: 575.98px) {
  .newsroom-page-header-title {
    font-size: clamp(1.5rem, 7.5vw, 1.75rem);
  }
}
</style>
